// src/components/Watermark.jsx
import { useMemo } from "react";

export function Watermark({ email }) {
  const label = email || "Al Mehraj";
  const today = new Date().toLocaleDateString("en-GB", {
    day: "numeric", month: "short", year: "numeric",
  });

  const dataUri = useMemo(() => {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="200">
      <g transform="rotate(-30, 160, 100)">
        <text x="160" y="92" font-family="Helvetica,Arial,sans-serif" font-size="13"
          fill="rgba(0,0,0,0.025)" text-anchor="middle" dominant-baseline="middle"
          font-weight="500">${label}</text>
        <text x="160" y="112" font-family="Helvetica,Arial,sans-serif" font-size="10"
          fill="rgba(0,0,0,0.018)" text-anchor="middle" dominant-baseline="middle">${today}</text>
      </g>
    </svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  }, [label, today]);

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 100,
        pointerEvents: "none",
        userSelect: "none",
        backgroundImage: `url("${dataUri}")`,
        backgroundRepeat: "repeat",
        backgroundSize: "320px 200px",
      }}
    />
  );
}
